import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export interface LegendKey {
  label: string;
  color: string;
  /** A filled swatch (series) or a short line (reference line). */
  kind?: 'swatch' | 'line';
}

export interface ChartLegendProps {
  keys: LegendKey[];
}

/** Manual legend so colours set per-cell in recharts still get a key. */
export const ChartLegend: React.FC<ChartLegendProps> = ({ keys }) => (
  <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" alignItems="center">
    {keys.map((key) => (
      <Stack key={key.label} direction="row" spacing={0.75} alignItems="center">
        <Box
          aria-hidden="true"
          sx={{
            width: key.kind === 'line' ? 14 : 10,
            height: key.kind === 'line' ? 2 : 10,
            borderRadius: key.kind === 'line' ? 1 : '3px',
            bgcolor: key.color,
            flex: 'none',
          }}
        />
        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
          {key.label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
